var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.667 16.667c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6m10.942 3.057-3.95-3.95a8.62 8.62 0 0 0 1.674-5.107A8.666 8.666 0 0 0 10.667 2 8.666 8.666 0 0 0 2 10.667a8.666 8.666 0 0 0 8.667 8.666 8.62 8.62 0 0 0 5.106-1.674l3.95 3.95a1.33 1.33 0 0 0 1.886 0 1.33 1.33 0 0 0 0-1.885"
})));
export default SvgGemSearch;